import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { message } from 'antd';
import { pointNumFilterFunc, textAlignList } from 'utils/constant';
import { theme } from 'utils/style/theme';
import { bubbleSetApi } from 'apis/platform/bubbleSetApis';
import DefaultInput from 'components/input/DefaultInput';
import DefaultSelect from 'components/select/DefaultSelect';
import ToggleButton from 'components/button/ToggleButton';
import DefaultModal from 'components/modal/DefaultModal';
import DefaultButton from 'components/button/DefaultButton';
import DefaultForm from 'components/form/DefaultForm';
import { useTranslation } from 'react-i18next';
/**
 * * 플랫폼 관리 - 말풍선 세트 메인 - 수정
 */

const BubbleUpdateModal = ({ visible, setVisible, record, fetchData }) => {
  const { t } = useTranslation();

  const [inputData, setInputData] = useState(); // 수정할 데이터

  /// input 이벤트
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name !== 'set_name' && name !== 'remark') {
      if (pointNumFilterFunc(value)) {
        return false;
      }
    }
    setInputData({
      ...inputData,
      [name]: value,
    });
  };

  /// 정렬 타입 드롭다운
  const handleChangeTag = (val) => {
    setInputData({ ...inputData, tag_align_type: val });
  };
  /// 말풍선 토글 버튼
  const handleCheckedToggle = (e) => {
    setInputData({ ...inputData, tag_color_affect: e.target.checked ? 1 : 0 });
  };

  /// 서버 전송
  const handleSubmit = async () => {
    const res = await bubbleSetApi.update(inputData?.set_id, inputData);
    if (!res) {
      return false;
    }
    setVisible(false);
    fetchData();
    message.success(t('bubble.editBalloonModal.successMessage'), 1);
  };

  useEffect(() => {
    if (record) {
      setInputData(record);
    }
  }, [visible]);
  return (
    <DefaultModal
      title={t('bubble.editBalloonModal.title')}
      visible={visible}
      onCancel={() => {
        setVisible(false);
      }}
      width={600}
      style={{
        top: 50,
      }}
      footer={
        <DefaultButton onClick={handleSubmit}>
          {t('bubble.editBalloonModal.edit')}
        </DefaultButton>
      }
    >
      <DefaultForm>
        <DefaultInput
          title={t('bubble.editBalloonModal.name')}
          name='set_name'
          value={inputData?.set_name}
          onChange={handleInputChange}
        />
        <DefaultInput
          title={t('bubble.editBalloonModal.memo')}
          name='remark'
          value={inputData?.remark}
          onChange={handleInputChange}
        />
        <HorizonWrap>
          <DefaultInput
            title={t('bubble.editBalloonModal.regularFontSize')}
            type='number'
            pattern='[0-9]+'
            name='normal_font_size'
            value={inputData?.normal_font_size}
            onChange={handleInputChange}
          />
          <DefaultInput
            title={t('bubble.editBalloonModal.largeFontSize')}
            type='number'
            pattern='[0-9]+'
            name='big_font_size'
            value={inputData?.big_font_size}
            onChange={handleInputChange}
          />
        </HorizonWrap>
        <HorizonWrap>
          <DefaultInput
            title={t('bubble.editBalloonModal.lineSpacing')}
            type='number'
            step={0.1}
            name='line_space'
            value={inputData?.line_space}
            onChange={handleInputChange}
          />
        </HorizonWrap>
        <SubTitle>{t('bubble.editBalloonModal.nameTagSetting')}</SubTitle>
        <HorizonWrap>
          <DefaultInput
            title={t('bubble.editBalloonModal.nameTagLeftMargin')}
            type='number'
            step={0.1}
            name='tag_textarea_left'
            value={inputData?.tag_textarea_left}
            onChange={handleInputChange}
          />
          <DefaultInput
            title={t('bubble.editBalloonModal.nameTagRightMargin')}
            type='number'
            name='tag_textarea_right'
            value={inputData?.tag_textarea_right}
            onChange={handleInputChange}
            step={0.1}
          />
        </HorizonWrap>
        <HorizonWrap>
          <DefaultInput
            title={t('bubble.editBalloonModal.nameTagTopMargin')}
            type='number'
            step={0.1}
            name='tag_textarea_top'
            value={inputData?.tag_textarea_top}
            onChange={handleInputChange}
          />
          <DefaultInput
            title={t('bubble.editBalloonModal.nameTagBottomMargin')}
            type='number'
            placeholder='0'
            name='tag_textarea_bottom'
            value={inputData?.tag_textarea_bottom}
            onChange={handleInputChange}
            step={0.1}
          />
        </HorizonWrap>
        <HorizonWrap>
          <DefaultSelect
            title={t('bubble.editBalloonModal.nameTagTextAlignment')}
            name='tag_align_type'
            placeholder='정렬 타입을 선택해주세요.'
            optionList={textAlignList}
            value={inputData?.tag_align_type}
            onChange={handleChangeTag}
          />

          <div className='bubble_color_wrap'>
            <h5>{t('bubble.editBalloonModal.balloonColorImpact')}</h5>
            <p>{t('bubble.editBalloonModal.nameTagColorAffectsBalloon')}</p>
            <ToggleButton
              name='tag_color_affect'
              onChange={handleCheckedToggle}
              value={inputData?.tag_color_affect}
              checked={inputData?.tag_color_affect === 1 ? true : false}
            />
          </div>
        </HorizonWrap>
      </DefaultForm>
    </DefaultModal>
  );
};

export default BubbleUpdateModal;

const HorizonWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  > div {
    width: 45%;
  }
  .bubble_color_wrap {
    text-align: left;
    h5 {
      color: ${theme.colors.blue_7};
      font-size: ${theme.fontSizes.md};
      font-weight: 350;
    }
    p {
      font-size: 0.8rem;
      color: ${theme.colors.gray_2};
    }
  }
`;

const SubTitle = styled.h4`
  border-bottom: 1px solid ${theme.colors.blue_03};
  font-size: ${theme.fontSizes.large};
  font-weight: 700;
  margin-top: 1rem;
  margin-bottom: 1.5rem;
  color: ${theme.colors.blue_7};
`;
